import service from './config.api';

export const APPLICATIONS_ENDPOINT = 'configurations/admin/applications';
export const APPLICATION_ENDPOINT = applicationId =>
  `${APPLICATIONS_ENDPOINT}/${applicationId}`;

// endpoints
service.getApplication = async applicationId => {
  const response = await service.get(APPLICATION_ENDPOINT(applicationId));
  return response.data;
};

service.getApplications = async params => {
  const response = await service.get(APPLICATIONS_ENDPOINT, { params: params });
  return response.data;
};

service.createApplication = async application => {
  const response = await service.post(APPLICATIONS_ENDPOINT, application);
  return response.data;
};

service.updateApplication = async (applicationId, application) => {
  const response = await service.patch(
    APPLICATION_ENDPOINT(applicationId),
    application
  );

  return response.data;
};

service.deleteApplication = async applicationId => {
  const response = await service.delete(APPLICATION_ENDPOINT(applicationId));
  return response.data;
};

export default service;
